export default __webpack_public_path__ + "static/media/IMG_4411.1ed48a37.jpg";